import React, { useState, useEffect } from "react";
import "../assets/css/Header.css";
import { Menu } from "../models/menu";
import { IoMdMenu } from "react-icons/io";
import { Link, useNavigate } from "react-router-dom";
import { hideMenu, showMenu } from "../utils";

import ReactCountryFlag from "react-country-flag";
import { useLanguage } from "../LanguageContext";
import { LanguageCode, useTranslate } from "../services/translation";
import LazyImage from "./LazyImage";
import { LANGUAGES } from "../config/languages";

interface propsType{
  menu: Menu[];
  menuChange: (index: number) => void;
}

interface langType{
  countryCode: string;
  name: LanguageCode;
  checked: boolean;
}

const Header = ({menu, menuChange} : propsType) => {
  const { setLanguage, language } = useLanguage();
  const { translate } = useTranslate();
  const navigate = useNavigate();
  const [langList, setLangList] = useState<langType[]>(
    LANGUAGES.map(lang => ({
      countryCode: lang.countryCode,
      name: lang.name,
      checked: lang.name === language
    }))
  );
  const defaultLang = LANGUAGES.find(l => l.name === language) || LANGUAGES[0];
  const [langSelected, setLang] = useState<langType>({
    countryCode: defaultLang.countryCode,
    name: defaultLang.name,
    checked: true
  });
  const [langPopoverToggle, setLangPopoverToggle] = useState<boolean>(false);

  useEffect(() => {
    setLangList(prev =>
      prev.map(item => ({
        ...item,
        checked: item.name === language
      }))
    );

    const currentLang = LANGUAGES.find(l => l.name === language);
    if (currentLang) {
      setLang({
        countryCode: currentLang.countryCode,
        name: currentLang.name,
        checked: true
      });
    }
  }, [language]);

  const changeLang = (lang: langType) => {
    const updatedLangList = langList.map(item=>{
      item.checked = item.name === lang.name;
      return item;
    });
    setLangList(updatedLangList);
    setLang(lang);
    setLangPopoverToggle(false);
    setLanguage(lang.name);

    // Navigate to new language URL
    const currentPath = window.location.pathname;
    const pathSegments = currentPath.split('/').filter(Boolean);

    const langNames = LANGUAGES.map(l => l.name);
    if (langNames.includes(pathSegments[0] as any)) {
      pathSegments[0] = lang.name;
    } else {
      pathSegments.unshift(lang.name);
    }

    const newPath = '/' + pathSegments.join('/');
    navigate(newPath);
  }

  const getLanguagePrefixedLink = (link: string) => {
    return `/${language}${link}`;
  };

  return (
  <>
  <div className="header height-60 flex a-i-center j-c-between">
    <Link to={getLanguagePrefixedLink('/')}>
      <div className="white name flex a-i-center max-content bold">
        <div className="logo-container">
          <LazyImage alt="logo" src="https://upload-api.bemanjary.com/api/v1/upload/file?object_name=public1776702904345.png"/>
        </div>
        <strong className="white left-10">GENCE LUCIEN</strong>
      </div>
    </Link>
    <div id="web-menu" className="flex a-i-center">
      <ul className="menu flex a-i-center">
        {menu.map((item: Menu, key)=><li className="left-40" key={key}>
          <Link to={getLanguagePrefixedLink(item.link)} className={`${item.cliqued ? 'white bold' : 'light'}`}>{translate(item.label)}</Link>
        </li>)}
      </ul>
      <div className="relative">
        <button className="lang-btn left-40" onClick={()=>setLangPopoverToggle(!langPopoverToggle)}>
        <ReactCountryFlag countryCode={langSelected.countryCode} svg alt={langSelected.name} style={{height: '30px', width: '30px'}}/>
        <span>{langSelected.name}</span>
        </button>
        {langPopoverToggle && <div className="absolute lang-popover">
          {langList.map((item, key)=><button key={key} onClick={()=>changeLang(item)}>
            <span className={'status ' + (item.checked ? 'checked' : '')}></span>
            <ReactCountryFlag countryCode={item.countryCode} alt={item.name} svg style={{height: '30px', width: '30px'}}/>
            <span className="label">{item.name}</span>
          </button>)}
        </div>}
      </div>
    </div>
    <div className="menu-btn-lang-mobile">
      <div className="relative">
          <button className="lang-btn" onClick={()=>setLangPopoverToggle(!langPopoverToggle)}>
          <ReactCountryFlag countryCode={langSelected.countryCode} alt={langSelected.name} svg style={{height: '30px', width: '30px'}}/>
          <span>{langSelected.name}</span>
          </button>
          {langPopoverToggle && <div className="absolute lang-popover">
            {langList.map((item, key)=><button key={key} onClick={()=>changeLang(item)}>
              <span className={'status ' + (item.checked ? 'checked' : '')}></span>
              <ReactCountryFlag countryCode={item.countryCode} alt={item.name} svg style={{height: '30px', width: '30px'}}/>
              <span className="label">{item.name}</span>
            </button>)}
          </div>}
        </div>
        <button id="mobile-menu-btn" className="white left-10" onClick={()=>showMenu()}>
        <IoMdMenu />
      </button>
      </div>
  </div>
  <div className="mobile-menu fixed"  onClick={(e)=>{
    const target = e.target as HTMLElement;
    if (target.closest && !target.closest("#mobile-menu-box")) {
        hideMenu();
    }
  }}>
    <div id="mobile-menu-box" className="fixed mobile-menu-box gradient-bg">
      <div className="logo-mobile-container">
        <div className="logo-mobile-box">
          <LazyImage alt="logo" src="https://upload-api.bemanjary.com/api/v1/upload/file?object_name=public1776702904345.png"/>
        </div>
        <h2 className="white">GENCE LUCIEN</h2>
      </div>
      <ul>
        {menu.map((item: Menu, key)=><li className="left-40" key={key}>
          <Link to={getLanguagePrefixedLink(item.link)} className={`${item.cliqued ? 'white bold' : 'light'}`}>{translate(item.label)}</Link>
        </li>)}
        <li className="lang">
        </li>
      </ul>
    </div>
  </div>
  </>);
};

export default Header;
